import {
  afterNextRender,
  Component,
  inject,
  Injector,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { HeaderComponent, NavComponent, NavigationItem } from '@cvx/nextpage';
import { CalAngularService } from '@cvx/cal-angular';
import { UserDetails } from '../../core/models/app-user.models';
import { NgOptimizedImage } from '@angular/common';

@Component({
  standalone: true,
  imports: [HeaderComponent, NavComponent, NgOptimizedImage],
  selector: 'app-header',
  styleUrl: './header.scss',
  templateUrl: './header.html',
})
export class Header implements OnChanges {
  @Input() navigationItems: NavigationItem[] = [];
  @Input() welcomeMessage: string = '';
  currentUser: UserDetails[] = [];

  private readonly calService = inject(CalAngularService);
  private readonly injector = inject(Injector);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['welcomeMessage']?.currentValue) {
      this.attachLogoutButton();
    }
  }

  /** HEADER: Attach logout button to header welcome area once the @if block has rendered */
  private attachLogoutButton(): void {
    afterNextRender(
      () => {
        const login = document.getElementById('login');
        const logout = document.querySelector('.logout');
        if (login && logout) {
          login.appendChild(logout);
        }
      },
      { injector: this.injector },
    );
  }

  /** Handles the user sign-out process */
  signOut(): void {
    this.calService.userInitiatedSignOut().subscribe();
  }
}
